<template>
  <ModalDialog
    ref="dialog"
    title="Claude Configuration"
    icon="fa-cog"
    :submitting="submitting"
    submitTitle="Update"
    sizeClass="modal-xl"
    :submitDisabled="false"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="claudeForm" :labelColumnSize="3">
      <LoadingPanel ref="loadingPanel" @update="loading = $event" />
      <TabbedBox v-if="!loading">
         <template v-slot:tablist>
          <Tab tabid="tab-api" :first="true">
            <i class="far fa-briefcase"></i> API
          </Tab>
        </template>

        <template v-slot:tabcontent>
          <TabPage :first="true" tabid="tab-api">
            <NotificationBar type="info">
              <NotificationBarTitle>Claude API Setup</NotificationBarTitle>
              <ul>
                <li>This will link Synergy to Claude via the API Key for all prompts &amp; AI messaging</li>
                <li>Synergy does NOT offer token credits or pricing. This is handled directly via your Claude account</li>
                <li>Please setup spend limits &amp; email notifications within the Claude console to help control spending of tokens from Claude</li>
                <li>All conversations are AI generated and may be inaccurate or misleading. Please verify important information</li>
              </ul>
            </NotificationBar>
            
            <ContentTitle>Claude API</ContentTitle>

            <FormRow label="API Key" helpTip="Create an API key in the Claude Platform Console within Claude">
              <FormInputText v-model="claudeOptions.apiKey" placeholder="API Key" />
            </FormRow>
            <FormRow label="Model" helpTip="The Claude model to use for all agent conversations & reports">
              <FormSelect v-model="claudeOptions.model" placeholder="Model" :options="aiModelLookup" note="Different models incur different costs. Please monitor Claude costs during usage" />
            </FormRow>

            <FormRow label="Effort" helpTip="The effort level for the Claude model">
              <FormSelect v-model="claudeOptions.effort" placeholder="Effort" :options="aiEffortLookup" note="Different effort levels may impact response quality and cost" />
            </FormRow>

            <FormRow label="Max Output Tokens" helpTip="The maximum number of tokens the Claude model can generate in a single response">
              <FormInputText v-model="claudeOptions.maxOutputTokens" placeholder="Max Output Tokens" />
            </FormRow>
          </TabPage>

        </template>
      </TabbedBox>
      
    </FormGroup>
  </ModalDialog>
</template>

<style>
</style>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import IntegrationClaudeAPIService from '@/integrations/claude/services/apiService'

import { LinkTypes } from '@/store/types'

export default {
  name: 'ClaudeConfigDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    
  },
  data() {
    return {
      claudeForm: {},
      loading: true,
      submitting: false,
      defaultModel: 'claude-sonnet-4-6',
      claudeOptions: {
        apiKey: '',
        model: '',
        maxOutputTokens: 0,
        effort: ''
      },

      aiModelLookup: [
        { value: 'claude-opus-4-8', name: 'claude-opus-4-8' },
        { value: 'claude-opus-4-7', name: 'claude-opus-4-7' },
        { value: 'claude-sonnet-4-6', name: 'claude-sonnet-4-6' },
        { value: 'claude-sonnet-4-5', name: 'claude-sonnet-4-5' },
        { value: 'claude-haiku-4-5', name: 'claude-haiku-4-5' },
      ],
      aiEffortLookup: [
        { value: 'low', name: 'Low' },
        { value: 'medium', name: 'Medium' },
        { value: 'high', name: 'High' },
      ]
    }
  },
  created() {
    this.LinkTypes = LinkTypes
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    show(integrationData) {
      // Reset form
      this.claudeForm = {}
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true
      this.claudeForm = this.clearFormResponse()

      var updateData = {
        options: this.claudeOptions,
      }

      var claudeService = new IntegrationClaudeAPIService(this.$api)
      claudeService.updateConfig(updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.claudeForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    reloadData() {
      this.requestData()
    },
    requestData() {
      var claudeService = new IntegrationClaudeAPIService(this.$api)

      this.$refs.loadingPanel.startLoading()
      claudeService.getConfig()
      .then(response => {
        this.claudeOptions = response.data.options || {}

        if(!this.claudeOptions.apiKey)
          this.claudeOptions.apiKey = ''
        if(!this.claudeOptions.model)
          this.claudeOptions.model = this.defaultModel
        if(!this.claudeOptions.maxOutputTokens)
          this.claudeOptions.maxOutputTokens = 4096
        if(!this.claudeOptions.effort)
          this.claudeOptions.effort = 'high'
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error accessing Claude configuration data', err)
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })
    },
    
  }
}
</script>